var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9991 12.429C40.6761 13.015 39.2531 13.406 37.7521 13.591C39.2781 12.685 40.4521 11.24 41.0031 9.533C39.5751 10.37 37.9931 10.985 36.3101 11.309C34.9661 9.884 33.0491 9 30.9251 9C26.8451 9 23.5381 12.278 23.5381 16.32C23.5381 16.892 23.6051 17.449 23.7311 17.99C17.5931 17.682 12.1491 14.764 8.50709 10.336C7.86709 11.418 7.50709 12.685 7.50709 14.022C7.50709 16.563 8.80809 18.8 10.7921 20.118C9.58109 20.081 8.44109 19.744 7.44309 19.204C7.44309 19.226 7.44309 19.259 7.44309 19.29C7.44309 22.841 9.99009 25.798 13.3661 26.471C12.7491 26.64 12.0971 26.734 11.4251 26.734C10.9481 26.734 10.4831 26.68 10.0331 26.599C10.9731 29.501 13.7001 31.622 16.9311 31.685C14.4031 33.645 11.2191 34.819 7.75709 34.819C7.15909 34.819 6.57409 34.785 5.99609 34.715C9.26709 36.786 13.1511 38 17.3201 38C30.9051 38 38.3371 26.844 38.3371 17.166C38.3371 16.849 38.3271 16.533 38.3121 16.221C39.7621 15.197 41.0121 13.905 41.9991 12.429Z",
    fill: "#03A9F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2a2b1d1fafe47c3c83a3f261b99a6dd7.svg";
export { ForwardRef as ReactComponent };